import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "../AuthContext";

const ActiveBarContext = createContext(null);

export function ActiveBarProvider({ roleField, children }) {
  const { user, userBars } = useAuth();
  const [activeBarId, setActiveBarId] = useState("");

  const myBars = userBars.filter((bar) => bar[roleField] === user?.uid);

  useEffect(() => {
    if (!activeBarId && myBars.length > 0) {
      setActiveBarId(myBars[0].id);
    }
  }, [myBars, activeBarId]);

  const activeBar = myBars.find((b) => b.id === activeBarId) || null;

  return (
    <ActiveBarContext.Provider value={{ myBars, activeBarId, setActiveBarId, activeBar }}>
      {children}
    </ActiveBarContext.Provider>
  );
}

export function useActiveBar() {
  const ctx = useContext(ActiveBarContext);
  if (!ctx) {
    throw new Error("useActiveBar must be used inside an ActiveBarProvider");
  }
  return ctx;
}